import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { RoleSimpleView } from 'domains/Role/components'

const RoleList = (props) => {
  const { roles, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {roles?.length > 0 ? (
        roles?.map((role, index) => (
          <Col mb={4} key={role?._id || index} cw={listView ? 12 : [12, 6, 4]}>
            <RoleSimpleView
              actions={actions}
              index={index}
              isSelected={role?._id === selectedItem}
              onSelect={setSelectedItem}
              role={role}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No roles have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

RoleList.propTypes = {
  roles: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default RoleList
